import l from "react";
import { Text as d } from "../../../Text/Text.js";
import { X as p } from "@olxbr/ds-icons";
import { Chip as u } from "../../../Chip/Chip.js";
const f = _ref => {
  let {
    selectedItems: t,
    isOpen: a,
    onClick: i,
    children: m,
    items: o,
    className: r
  } = _ref;
  return l.createElement("div", {
    className: r
  }, t.map((n, c) => {
    const e = o.find(s => s.value === n);
    return e ? a ? l.createElement(u, {
      key: e.id,
      "aria-label": "Remover ".concat(e.label, " dos itens selecionados"),
      onClick: () => i(e.value),
      checked: !0
    }, e.label, l.createElement(p, null)) : l.createElement(d.BodyMedium, {
      key: e.id,
      tag: "p"
    }, e.label, c === t.length - 1 ? "" : ", ") : null;
  }), m);
};
export { f as Chips };